<template>
  <div class="btn-dashed-question" type="button" @click="$emit('click')">
    <i class="ph ph-plus" />
    <span>{{ text }}</span>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: "Adicionar pergunta"
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-dashed-question {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px;
  width: 100%;
  border-radius: 16px;
  font-size: 14px;
  border: 1px dashed var(--dark-20);
}
</style>
